import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Accordion, Image } from 'semantic-ui-react';
import {
  goLogin,
  logoutAction,
} from '../../../../../store/actions/auth.actions';
import twIcon from '../../../../../assets/images/tw_gray.svg';
import fbIcon from '../../../../../assets/images/fb_gray.svg';
import podIcon from '../../../../../assets/images/podcast.svg';
import classes from './sidebar.css';
import MyHuddleAccordion from './MyHuddleAccordion';

const SignedInSubMenu = ({ userName, logout }) => (
  <div>
    <span className={classes.italicText}>
      Welcome, {userName}
    </span>
    <MyHuddleAccordion />
    <Button className={classes.linkButton} onClick={logout}>
      SIGN OUT
    </Button>
  </div>
);

const SignedOutSubMenu = ({ login }) => (
  <Button className={classes.linkButton} onClick={login}>
    SIGN IN
  </Button>
);

const SocialMedia = () => (
  <span className={classes.socialMedia}>
    Follow Us
    <Image
      src={fbIcon}
      className={classes.icon}
      as="a"
      href="https://www.facebook.com/thehuddle"
      target="_blank"
    />
    <Image
      src={twIcon}
      className={classes.icon}
      verticalAlign="middle"
      as="a"
      href="https://www.twitter.com/TheHuddle"
      target="_blank"
    />
    <Image
      src={podIcon}
      className={classes.icon}
      as="a"
      href="https://thehuddle.com/category/fantasy-football-player-analysis-tips-advice-picks/fantasy-football-podcast/"
      target="_blank"
    />
  </span>
);

const SidebarUpperMenu = props => (
  <Accordion className={classes.upperMenu}>
    {props.isLoggedIn
      ? <SignedInSubMenu {...props} />
      : <SignedOutSubMenu {...props} />
    }
    <Button href="https://thehuddle.com/help-with-the-huddle-site/" className={classes.linkButton}>HELP</Button>
    <SocialMedia />
  </Accordion>
);

SidebarUpperMenu.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
};

SignedOutSubMenu.propTypes = {
  login: PropTypes.func.isRequired,
};

SignedInSubMenu.propTypes = {
  logout: PropTypes.func.isRequired,
  userName: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  userName: state.auth.user ? state.auth.user.fname : '',
  isLoggedIn: state.auth.loggedIn,
});

const mapDispatchToProps = dispatch => ({
  login: () => dispatch(goLogin),
  logout: () => dispatch(logoutAction),
});

const ConnectedSidebarUpperMenu = connect(mapStateToProps, mapDispatchToProps)(
  SidebarUpperMenu,
);

export default ConnectedSidebarUpperMenu;



// WEBPACK FOOTER //
// ./src/app/components/Nav/MobileNav/Sidebar/SidebarUpperMenu.js